import { combineReducers } from '@reduxjs/toolkit';

import createTicketsSlice, { initialState as ticketsInitialState } from './modules/tickets/slices';
import createSearchSlice, { initialState as searchInitialState } from './modules/search/slices';
import createModalsSlice, { initialState as modalsInitialState } from './modules/modals/slices';
import createChatsSlice, { initialState as chatsInitialState } from './modules/chats/slices';
import createFaqSlice, { initialState as faqInitialState } from './modules/faq/slices';
import createReleaseNotesSlice, { initialState as releaseNotesInitialState } from './modules/releaseNotes/slices';

import createHelpCenterSlice, {
  initialState as helpCenterInitialState,
} from './modules/helpCenter/slices';

import createNotificationsSlice, {
  initialState as notificationsInitialState,
} from './modules/notifications/slices';

const tickets = createTicketsSlice({
  name: 'tickets',
  initialState: ticketsInitialState,
  reducers: {},
});

const helpCenter = createHelpCenterSlice({
  name: 'helpCenter',
  initialState: helpCenterInitialState,
  reducers: {},
});

const search = createSearchSlice({
  name: 'search',
  initialState: searchInitialState,
  reducers: {},
});

const notifications = createNotificationsSlice({
  name: 'notifications',
  initialState: notificationsInitialState,
  reducers: {},
});

const modals = createModalsSlice({
  name: 'modals',
  initialState: modalsInitialState,
  reducers: {},
});

const chats = createChatsSlice({
  name: 'chats',
  initialState: chatsInitialState,
  reducers: {},
});

const faq = createFaqSlice({
  name: 'faq',
  initialState: faqInitialState,
  reducers: {},
});

const releaseNotes = createReleaseNotesSlice({
  name: 'releaseNotes',
  initialState: releaseNotesInitialState,
  reducers: {},
});

const ticketsActions = tickets.actions;
const helpCenterActions = helpCenter.actions;
const searchActions = search.actions;
const notificationsActions = notifications.actions;
const modalsActions = modals.actions;
const chatsActions = chats.actions;
const faqActions = faq.actions;
const releaseNotesActions = releaseNotes.actions;

const rootReducer = combineReducers({
  tickets: tickets.reducer,
  helpCenter: helpCenter.reducer,
  search: search.reducer,
  notifications: notifications.reducer,
  modals: modals.reducer,
  chats: chats.reducer,
  faq: faq.reducer,
  releaseNotes: releaseNotes.reducer
});

export {
  ticketsActions,
  rootReducer,
  helpCenterActions,
  searchActions,
  notificationsActions,
  modalsActions,
  chatsActions,
  faqActions,
  releaseNotesActions
};
